<template>
        <b-table
            :empty-text="this.$t('there_are_no_records')"
            bordered
            striped
            responsive
            :items="transferRequest"
            :fields="transferRequestsFields"
            show-empty
            class="mb-5 table-dropdown no-scrollbar border rounded document_request_dropdown">
        </b-table>
</template>
<script>
import qs from "qs";
import TransferOutRequestMentora from "@/services/TransferOutRequestMentora";

export default {
    name: "TransferOut",
    props:{
      filter:{
          type:Object
      }
    },
    data(){
        return {
            transferRequest: [],
            transferRequestsFields: [
                {
                    key: 'student_number',
                    label: this.$t('student_number').toUpper(),
                },
                {
                    key: 'name',
                    label: this.$t('first_name').toUpper(),
                },
                {
                    key: 'surname',
                    label: this.$t('last_name').toUpper(),
                },
                {
                    key: 'new_institution_name',
                    label: this.$t('new_institution').toUpper(),
                },

                {
                    key: 'reason',
                    label: this.$t('reason').toUpper(),
                },
                {
                    key: 'program_start_date',
                    label: this.$t('start_date').toUpper(),
                },
                {
                    key: 'status_name',
                    label: this.$t('status').toUpper(),
                },

            ],
        }
    },
    created() {
      this.getData()
    },
    methods:{
        getData(){
            const transferOutRequest = {
                ...this.filter,
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            }
            TransferOutRequestMentora.getAll(transferOutRequest)
                .then(response => {
                    this.transferRequest = response.data.data;
                }).catch(e => {
                this.showErrors(e);
            })

        }

    }
}
</script>

<style scoped>

</style>
